export default __webpack_public_path__ + "static/media/img--interiors-10.7425982d.jpg";